import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Chip, ChipProps } from '@mui/material';

type StatusType = 'success' | 'error' | 'warning' | 'info';

type CollectionStatusChipProps = {
  status: StatusType;
  label: string;
  count?: number;
} & Omit<ChipProps, 'icon' | 'color' | 'label'>;

export const CollectionStatusChip = ({
  status,
  label,
  count,
  ...chipProps
}: CollectionStatusChipProps) => {
  const getIcon = () => {
    switch (status) {
      case 'success':
        return <CheckCircleOutlineIcon sx={{ fontSize: '1.125rem' }} />;
      case 'error':
        return <ErrorOutlineIcon sx={{ fontSize: '1.125rem' }} />;
      case 'warning':
        return <WarningAmberIcon sx={{ fontSize: '1.125rem' }} />;
      default:
        return undefined;
    }
  };

  return (
    <Chip
      icon={getIcon()}
      label={count !== undefined ? count : label}
      color={status}
      size='small'
      variant='outlined'
      sx={{ '& .MuiChip-icon': { ml: 0.5 }, ...chipProps.sx }}
      {...chipProps}
    />
  );
};
